const extractPlainText = (richText: any): string => {
  if (!richText) return "";
  if (typeof richText === "string") return richText;
  if (!richText?.root?.children) return "";
  const walk = (nodes: any[]): string =>
    nodes
      .map((node: any) => {
        if (node.type === "text") return node.text || "";
        if (node.children) return walk(node.children);
        if (node.type === "linebreak") return " ";
        return "";
      })
      .join("");
  return richText.root.children
    .map((node: any) => walk([node]))
    .join(" ")
    .trim();
};

export default extractPlainText;
